import React from 'react';
import {Button} from "antd";
import RedButton from "./RedButton";
import classes from "./buttons.module.css";

const OrangeButton = (props) => {
    return (
        <Button {...props} className={classes.orangeBtn}>
            <span>{props.children}</span>
        </Button>
    );
};

OrangeButton.propTypes = {
    ...Button.propTypes, // Use Ant Design Button propTypes
};

export default OrangeButton;